class BaseUrlConfigStore {
  baseUrl: string;
  startPageUrl: string;

  constructor(baseUrl?) {
    this.baseUrl = baseUrl;
  }

  setBaseUrl(baseUrl) {
    this.baseUrl = baseUrl;
  }

  getBaseUrl() {
    return this.baseUrl;
  }

  setStartPage(pageUrl : string) {
    this.startPageUrl = pageUrl;
  }

  getStartPageUrl() {
    return this.startPageUrl;
  }
}

const BaseURLConfigStore = new BaseUrlConfigStore();

export default BaseURLConfigStore;
